/**
 * Admin authorization helpers.
 *
 * Admin status comes from the `role` claim the backend puts in the JWT at
 * login. This is a UI-level convenience only: the real enforcement lives on
 * the server, where every /dashboard/* route depends on `require_admin` and
 * re-reads the role from the database. Tampering with the token here buys
 * nothing — the API rejects it with 403.
 */
import { getToken, getTokenPayload } from "./session";

export const ROLE_USER = "USER";
export const ROLE_COMPANY_ADMIN = "COMPANY_ADMIN";

/** The current session's role, or null when nobody is signed in. */
export function getRole() {
  if (!getToken()) return null;
  return getTokenPayload()?.role || ROLE_USER;
}

/** True when the current session belongs to a company admin. */
export function isAdminAuthenticated() {
  return getRole() === ROLE_COMPANY_ADMIN;
}

/** True if this JWT carries the company-admin role. Used right after login,
 *  before the token is committed to storage. */
export function isAdminToken(token) {
  return getTokenPayload(token)?.role === ROLE_COMPANY_ADMIN;
}
